var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',{attrs:{"first-day-of-week":1,"lang":_vm.lang,"format":"DD.MM.YYYY"},model:{value:(_vm.valueLocal),callback:function ($$v) {_vm.valueLocal=$$v},expression:"valueLocal"}})}
var staticRenderFns = []

export { render, staticRenderFns }